<template>
  <md-checkbox v-model="localAgreement" size="small" label="阅读并同意" />
  <a class="agreement" :href="serviceAgreement" target="_blank">安得服务协议、</a>
  <a class="agreement" :href="privacyAgreement" target="_blank">隐私保护协议</a>
  <p class="register-btn">
    <template v-if="props.isPwdLogin">
      <md-button type="text" size="small" @click="toFindPassword">忘记密码</md-button>
    </template>
    <md-button type="text" size="small" @click="toRegister">立即注册</md-button>
  </p>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits, watch, defineExpose } from 'vue';
import '@/api/jsencrypt.js';
import { MdButton, MdCheckbox, MdMessageBox } from 'mdesign3';
import { serviceAgreement, privacyAgreement } from '@/config/const';
import { toFindPassword, toRegister } from '@/utils/index';

const props = defineProps<{
  isAgreement: boolean;
  loading: boolean;
  isPwdLogin?: boolean;
  submitFormFn: () => void;
}>();

const localAgreement = ref(props.isAgreement);
const emit = defineEmits(['update:loading', 'update:isAgreement']);

watch(localAgreement, (newValue) => {
  emit('update:isAgreement', newValue);
});

const agreementMsg = () => {
  MdMessageBox.confirm(
    `<a href="${serviceAgreement}" target="_blank">安得服务协议、</a>
        <a href="${privacyAgreement}" target="_blank">隐私保护协议</a>`,
    '阅读并同意',
    {
      customClass: 'agreement-msg',
      modalClass: 'agreement-modal',
      type: 'info',
      dangerouslyUseHTMLString: true,
      confirmButtonText: '同意并登录',
      cancelButtonText: '不同意',
      center: true,
      buttonSize: 'default',
    },
  )
    .then(() => {
      localAgreement.value = true;
      props.submitFormFn();
    })
    .catch(() => {
      localAgreement.value = false;
      emit('update:loading', false);
    });
};
defineExpose({
  agreementMsg,
});
</script>
<style lang="less">
.md-message-box.agreement-msg {
  .md-message-box__title {
    margin-bottom: 20px;
  }
}
.md-overlay.is-message-box.agreement-modal {
  background-color: rgba(0, 0, 0, 0.1);
  .md-message-box__container {
    padding: 0;
    .md-message-box__message,
    .md-message-box__message p {
      width: 100%;
      text-align: center;
      a {
        color: #2881ff;
      }
    }
  }
  .md-message-box--center .md-message-box__status {
    width: 22px;
    height: 22px;
    padding: 0;
    margin-top: 3px;
    line-height: 22px;
  }
}
</style>
